import './home.scss'

import {Image, wrap} from '@codeurs/front'
import {HomeChannelData} from 'campagne/types'
import React from 'react'
import {style} from 'util/campagne/style'
import {Layout} from 'views/campagne/layout'
import {BannerCta} from 'views/campagne/partials/banner'
import Blocks from 'views/campagne/partials/blocks'
import {CtaRegister} from 'views/campagne/partials/ctaregister'
import {FeaturedActions} from 'views/campagne/partials/featuredactions'
import {Raster} from 'views/campagne/partials/raster'
import {Theme} from 'views/campagne/theme'

const styles = style('home')

export const Home: React.FC<HomeChannelData> = wrap(Layout)(({...props}) => {
	const {blocks, cta, featured, intro, banner} = props

	return (
		<div class={styles}>
			<Theme.Container mod="shifted">
				<div class={styles('content')}>
					<div class={styles('content-blocks')}>
						<Blocks blocks={blocks} />
					</div>
					<div class={styles('content-cta')}>
						<div class={styles('content-cta-register')}>
							<CtaRegister
								link={cta.link}
								text={cta.text}
								title={cta.title}
								mod="greyraster"
							/>
						</div>
						<div class={styles('content-intro')}>
							<Image {...intro.image} class={styles('content-intro-image')} />
							<span class={styles('content-intro-title')}>
								<Theme.H2
									mod={{
										small: true,
										green: true,
										slantedtoleft: true,
										rastered: true
									}}
								>
									{intro.text}
								</Theme.H2>
							</span>
						</div>
					</div>
				</div>
			</Theme.Container>
			<div class={styles('featured')}>
				<Raster>
					<Theme.Container>
						<FeaturedActions {...featured} />
					</Theme.Container>
				</Raster>
			</div>
			{banner && (
				<Theme.Container>
					<div class={styles('ctagift')}>
						<BannerCta
							headingLeft={banner.title1}
							headingRight={banner.title2}
							description={banner.text}
							ctaLink={banner.link}
							{...banner.gift}
						/>
					</div>
				</Theme.Container>
			)}
		</div>
	)
})
